import TemplateCard, { TemplateCardProps } from './TemplateCard';

export type { TemplateCardProps };
export default TemplateCard;
